<template>
  <div class="img">
    <img src="/static/img/service_intro/mortgage/mortgage-banner.png"/>
    <!--<div class="container">-->
      <!--<div>-->
        <!--<span>做木材生意资金短缺 木材码头推荐仓单质押</span>-->
      <!--</div>-->
      <!--<div class="line">-->
        <!--<span>手续简单 放款快</span>-->
      <!--</div>-->
    <!--</div>-->
  </div>
  <!--<img src="/static/wood.png" align="center"/>-->
</template>

<script>
  export default{
    name: 'homeMortgageBanner'
  }
</script>

<style scoped>

  div.img {
    width: auto;
    height: auto;
    margin: 0;
    padding: 0;
    display: flex;
  }

  div.container {
    padding: 0;
    margin: auto;
    width: auto;
  }

  span {
    width: auto;
    font-weight: 700;
    font-style: normal;
    font-family: 'Helvetica-Bold', 'Helvetica Bold', 'Helvetica';
    background-color: rgba(215, 215, 215, 1);
    font-size: 32px;
    white-space: nowrap;
    color: #333333;
  }
  .line {
    margin-top: 20px;
  }
  img {
    width: 100%;
    height: 100%;
    /*width: 1100px;*/
    /*height: 350px;*/
  }

</style>



// WEBPACK FOOTER //
// HomeMortgageBanner.vue?01ca4664